import { Control, FieldValues, FormState } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import Checkbox from '../../forms/Checkbox';
import {
  Permission,
  PermissionAction,
  PermissionResource,
  PermissionScope,
} from '../../../data/models/permission.model';
import { UserGroup } from '../../../data/models/user-group.model';
import securityUtils from '../../../services/securityUtils';

interface GroupPermissionsFormProps {
  permissions: Permission[];
  resources: PermissionResource[];
  actions: PermissionAction[];
  scopes: PermissionScope[];
  control: Control<FieldValues, object>;
}

export default function GroupPermissionsForm({
  permissions,
  resources,
  actions,
  scopes,
  control,
}: GroupPermissionsFormProps) {
  const { t } = useTranslation('common');

  return (
    <>
      {permissions.map((p) => {
        const label = securityUtils.getPermissionName(
          p,
          resources,
          actions,
          scopes,
        );
        const desc = p.description ? ` (${p.description})` : '';
        return (
          <Checkbox
            key={p.userPermissionID}
            label={`${label}${desc}`}
            name={`PermissionID_${p.userPermissionID}`}
            control={control}
          />
        );
      })}
    </>
  );
}
